// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"e9caad99","518":"ff362d1c"}[chunkId] + ".chunk.css";
};